<script>
import { ScTable, ScTableColumn, ScTableEmpty, ScTag, ScTooltip } from '@intelipost-js/secure-components';
import ErrorMessages from './ErrorMessages/ErrorMessages.json';
import billingTamplateColumnsEnum from '../../../enum/billing-tamplate-columns.enum';

export default {
  name: 'BillingFilesTable',
  data() {
    return {
      emptyTableTemplate: `
        <p style="font-weight: bold; font-size: 1.5em">Nenhuma fatura encontrada</p>
      `,
      statusLabelMap: {
        WAITING: { label: 'Aguardando processamento' },
        PROCESSING: { label: 'Em processamento' },
        SUCCESS: { label: 'Processamento concluído' },
        ERROR: { label: 'Erro no processamento' },
      },
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    files: {
      type: Array,
      required: true,
    },
  },
  methods: {
    loadErrorMessage(row) {
      const isKnownError = row.errorMessageKey && ErrorMessages[row.errorMessageKey];
      let rawMessage = isKnownError ? ErrorMessages[row.errorMessageKey] : ErrorMessages['billing.process.unknown.error'];
      if (row.errorMessageKey) {
        const replaceableKeys = ['errorMappedValue', 'errorColumnLetter', 'errorRowNumber'];
        Object.keys(row)
        .filter(key => replaceableKeys.includes(key) && !!row[key])
        .forEach((key) => {
          const value = key === 'errorMappedValue' ? billingTamplateColumnsEnum[row[key]].label : row[key];
          rawMessage = rawMessage.replace(`{${key}}`, value);
        });
      }

      return rawMessage;
    },
  },
  components: {
    ScTable,
    ScTableColumn,
    ScTableEmpty,
    ScTag,
    ScTooltip,
  },
};
</script>

<template>
  <sc-table
    :loading="loading" :data="files"
    :bordered="false" :hoverable="false" :striped="false" :scrollable="false">
    <template slot-scope="{ row }">
      <sc-table-column label="Arquivo" :centered="false">
        {{ row.filename }}
      </sc-table-column>
      <sc-table-column label="Fatura" :centered="false">
        {{ row.billingName }}
      </sc-table-column>
      <sc-table-column label="Modelo" :centered="false">
        {{ row.billingTemplateName }}
      </sc-table-column>
      <sc-table-column label="Adicionada em" :centered="false">
        {{ row.createdAt | date('DD/MM/YY - HH:mm') }}
      </sc-table-column>
      <sc-table-column label="Vencimento em" :centered="false">
        {{ row.expirationDate | date('DD/MM/YY') }}
      </sc-table-column>
      <sc-table-column label="Status" :centered="false">
        <sc-tooltip
          position="is-left"
          :active="row.status === 'ERROR'"
          :label="loadErrorMessage(row)"
          type="is-dark" 
          multilined append-to-body>
            <sc-tag size="is-medium">
              <i class="fas fa-circle" :class="[`icon__${row.status.toLowerCase()}`]"></i>
              {{ statusLabelMap[row.status].label }}
            </sc-tag>
        </sc-tooltip>
      </sc-table-column>
    </template>
    <template slot="empty">
      <sc-table-empty icon="box-open" :message="emptyTableTemplate"/>
    </template>
  </sc-table>
</template>

<style scoped lang="scss">
@import "~@intelipost-js/secure-ui/src/scss/variables"; //eslint-disable-line

td {
  color: #010906;
}

.icon {

  &__waiting, &__processing {
    color: #AA7CE7;
  }

  &__error {
    color: #C8323B;
  }

  &__success {
    color: green;
  }

}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/billing/pages/files/components/BillingFilesTable.vue